import dayjs from 'dayjs'

// Prikaz datuma u hrvatskom obliku, za cijelu aplikaciju.
//
// Prazan datum nije greska nego podatak koji jos nije upisan (npr. novi
// korisnik nema datum pocetka rada), pa se prikazuje kao prazno polje.
// Bez te provjere dayjs je vracao dvije krive stvari:
//
//   dayjs(null)       -> "Invalid Date"  - pisalo je na ekranu kao vrijednost
//   dayjs(undefined)  -> danasnji datum  - gore od svega, jer izgleda tocno
//
// Tekst koji uopce nije datum isto ide u prazno; bolje je ne prikazati nista
// nego prikazati izmisljeni datum.
function dateFormat (inputDate) {
  if (!inputDate) { return '' }
  const datum = dayjs(inputDate)
  if (!datum.isValid()) { return '' }
  return datum.format('DD.MM.YYYY')
}
export default dateFormat
